export const specialSlider = (Splide, AutoScroll) => {

    if (document.getElementById('special-slider')) {

        const options1 = { // 1 slide
            perPage: 1,
            drag: false,
            autoScroll: false,
            focus: 'center',
            arrows: false,
            pagination: false,
            fixedWidth: 400,
            gap: 0,
        };

        const options2 = { // 2 slides
            perPage: 2,
            drag: false,
            autoScroll: false,
            focus: 'center',
            arrows: false,
            pagination: false,
            fixedWidth: 400,
            gap: 0,
            breakpoints: {
                767: {
                    perPage: 1,
                    drag: 'free',
                    autoScroll: {speed: 1},
                },
            },
        };

        const options3 = { // 3 slides
            perPage: 3,
            drag: false,
            autoScroll: false,
            focus: 'center',
            arrows: false,
            pagination: false,
            fixedWidth: 400,
            gap: 0,
            breakpoints: {
                1024: {
                    perPage: 2,
                    drag: 'free',
                    autoScroll: {speed: 1},
                },
                767: {
                    perPage: 1,
                    drag: 'free',
                    autoScroll: {speed: 1},
                },
            },
        };

        const options4 = { // 4+ slides
            type: 'loop',
            drag: 'free',
            autoScroll: {speed: 1},
            perPage: 3,
            focus: 'center',
            arrows: false,
            pagination: false,
            breakpoints: {
                1024: {
                    perPage: 3,
                },
                767: {
                    perPage: 3,
                },
                640: {
                    perPage: 1,
                },
            },
        };

        let splideOptions = null;

        if (sliderCount === 1) {
            splideOptions = options1;
        } else if (sliderCount === 2) {
            splideOptions = options2;
        } else if (sliderCount === 3) {
            splideOptions = options3;
        } else {
            splideOptions = options4;
        }


        new Splide('#special-slider', splideOptions).mount({AutoScroll});
    }
}

export const logoSlider = (Splide, AutoScroll) => {

    if (document.getElementById('logo-slider')) {
        new Splide('#logo-slider', {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            arrows: false,
            perPage: 8,
            pagination: false,
            autoScroll: {
                speed: 1,
            },
            breakpoints: {
                1024: {
                    perPage: 8,

                },
                767: {
                    perPage: 6,

                },
                640: {
                    perPage: 4,

                },
            },
        }).mount({AutoScroll});
    }
}

export const homeSpecialSlider = (Splide) => {

    if (document.getElementById('home-special-slider')) {
        new Splide('#home-special-slider', {
            type: 'loop',
            autoplay: true,
            heightRatio: 0.3,
        }).mount();
    }
}